import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'
import {
  DROP_LIST,
  PANEL_NAVIGATE,
  SET_FILTER,
  SET_LOADING,
  SET_TICKETS,
  TOGGLE_PANEL,
} from 'modules/Tickets/types'

const initialState = {
  openPanel: false,
  router: {
    route: 'list',
    params: {},
  },
  loading: true,
  data: [],
  filters: null,
  loaded: false,
  loadFailed: false,
  pagination: {
    page: 1,
    limit: 50,
    total: 0,
  },
}

const setList = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: [...state.data].concat(payload.data),
    pagination: {
      ...state.pagination,
      ...payload.pagination,
    },
    loading: false,
  })

const toggleLoading = (state, { payload }) =>
  updateObject(state, { ...payload })

const dropList = (state) =>
  updateObject(state, { data: [], loaded: false, loadFailed: false })

const ticketsSetFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return toggleLoading(state, action)
    case SET_TICKETS:
      return setList(state, action)
    case DROP_LIST:
      return dropList(state, action)
    case SET_FILTER:
      return ticketsSetFilter(state, action)
    case TOGGLE_PANEL:
      return updateObject(state, { openPanel: action.payload })
    case PANEL_NAVIGATE:
      return updateObject(state, { router: action.payload, openPanel: true })
    default:
      return state
  }
}

export default reducer
